import { render, staticRenderFns } from "./BacRodeoTile.vue?vue&type=template&id=53afb3f4&scoped=true&"
import script from "./BacRodeoTile.vue?vue&type=script&lang=ts&"
export * from "./BacRodeoTile.vue?vue&type=script&lang=ts&"
import style0 from "./BacRodeoTile.vue?vue&type=style&index=0&id=53afb3f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53afb3f4",
  null
  
)

export default component.exports